import * as React from "react"
import { Box, Button, IconButton, LinearProgress, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

export default function TourTooltip({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    skipProps,
    tooltipProps,
    isLastStep,
    size,
}) {
    const progress = ((index + 1) / size) * 100

    return (
        <Box
            {...tooltipProps}
            sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                boxShadow: "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
                maxWidth: 380,
                minWidth: 290,
                overflow: "hidden",
            }}
        >
            {/* Progress bar */}
            <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                    height: 3,
                    backgroundColor: "primary.lighter",
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: "primary.light",
                    },
                }}
            />

            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, pt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                        sx={{
                            backgroundColor: "primary.lighter",
                            borderRadius: "8px",
                            width: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <IconSeeker icon="route" iconType="fontAwesome" sx={{ fontSize: 14, color: "primary.main" }} />
                    </Box>
                    <Typography variant="caption" sx={{ color: "text.disabled", fontWeight: 500 }}>
                        {index + 1} / {size}
                    </Typography>
                </Box>
                <IconButton {...closeProps} size="small" sx={{ color: "text.disabled", "&:hover": { backgroundColor: "primary.lighter" } }}>
                    <IconSeeker icon="xmark" iconType="fontAwesome" sx={{ fontSize: 14 }} />
                </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ px: 2.5, pt: 1.5, pb: 2 }}>
                {step.title && (
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75, color: "text.primary" }}>
                        {step.title}
                    </Typography>
                )}
                <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.6 }}>
                    {step.content}
                </Typography>
            </Box>

            {/* Footer */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2.5,
                    pb: 2,
                }}
            >
                <Button
                    {...skipProps}
                    size="small"
                    sx={{
                        textTransform: "none",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        backgroundColor: "text.disabled",
                        borderRadius: "8px",
                        px: 2,
                        "&:hover": { backgroundColor: "text.secondary" },
                    }}
                >
                    {skipProps.title}
                </Button>
                <Box sx={{ display: "flex", gap: 1 }}>
                    {index > 0 && (
                        <Button
                            {...backProps}
                            variant="outlined"
                            size="small"
                            sx={{
                                textTransform: "none",
                                borderRadius: "8px",
                                borderColor: "divider",
                                color: "text.secondary",
                                fontWeight: 600,
                                fontSize: "0.8rem",
                                px: 2,
                                "&:hover": { borderColor: "primary.light", backgroundColor: "primary.lighter" },
                            }}
                        >
                            {backProps.title}
                        </Button>
                    )}
                    {continuous && (
                        <Button
                            {...primaryProps}
                            variant="contained"
                            size="small"
                            sx={{
                                textTransform: "none",
                                borderRadius: "8px",
                                fontWeight: 600,
                                fontSize: "0.8rem",
                                px: 2,
                                boxShadow: "none",
                                "&:hover": { boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)" },
                            }}
                        >
                            {primaryProps.title}
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
    )
}
